import { Badge } from '@dixa/lib-shared-habla';
import { PublicationStatus } from 'lib-knowledge-management-common/graphql';

type StatusBadgeProps = {
  publicationStatus: PublicationStatus;
  className?: string;
};

export function StatusBadge({
  publicationStatus,
  className,
}: StatusBadgeProps): JSX.Element {
  switch (publicationStatus) {
    case PublicationStatus.Published:
      return (
        <Badge size="medium" variant="primary" className={className}>
          Published
        </Badge>
      );
    case PublicationStatus.Unpublished:
      return (
        <Badge size="medium" variant="primary" className={className}>
          Unpublished
        </Badge>
      );
    default:
      return (
        <Badge size="medium" variant="primary" className={className}>
          Draft
        </Badge>
      );
  }
}
